import { call, put, takeEvery } from 'typed-redux-saga'
import {
	NOTIFICATION_TYPE,
	NotificationPopupNS,
	notificationPopupSlice,
	errorHandler,
} from 'Modules'
import { i18n } from 'LibNeo'

function* showMessageSaga(action: NotificationPopupNS.ShowMessage) {
	try {
		const message = action.payload

		const hasErrorsData = Boolean(message.data?.length)
		const hasErrors = Boolean(message.errors?.length)
		const hasPrepareErrors = Boolean(message.prepareErrors?.length)
		const hasFileErrors = Boolean(message.fileErrors?.length)
		const hasSomeErrors = hasErrorsData || hasErrors || hasFileErrors

		if (message.message && !hasSomeErrors) {
			yield* put(
				notificationPopupSlice.actions.add({
					type: message.type,
					body: message.message,
				})
			)
		}

		if (message.type !== NOTIFICATION_TYPE.ERROR) return

		if (hasErrorsData) {
			for (let i = 0; i < message.data.length; i += 1) {
				const error = message.data[i]
				const keys = Object.keys(error)
				yield* put(
					notificationPopupSlice.actions.add({
						type: message.type,
						body: i18n(`orders.error_${keys[0]}_${error[keys[0]]}`),
					})
				)
			}
		}

		if (hasErrors) {
			for (let i = 0; i < message.errors.length; i += 1) {
				const error = message.errors[i]
				const keys = Object.keys(error)
				for (let j = 0; j < keys.length; j += 1) {
					const key = keys[j]
					yield* put(
						notificationPopupSlice.actions.add({
							type: message.type,
							body: `${i18n(`errors.${key}`)} ${i18n(`errors.${error[key]}`)}`,
						})
					)
				}
			}
		}

		if (hasFileErrors) {
			for (let i = 0; i < message.fileErrors.length; i += 1) {
				const error = message.fileErrors[i]
				const keys = Object.keys(error)
				for (let j = 0; j < keys.length; j += 1) {
					const key = keys[j]
					yield* put(
						notificationPopupSlice.actions.add({
							type: message.type,
							body: `${i18n(`errors.${key}`)} ${i18n(`${error[key]}`)}`,
						})
					)
				}
			}
		}

		if (hasPrepareErrors) {
			for (let i = 0; i < message.prepareErrors.length; i += 1) {
				const error = message.prepareErrors[i]
				for (let j = 0; j < error.length; j += 1) {
					const err = error[j]
					yield* put(
						notificationPopupSlice.actions.add({
							type: message.type,
							body: err,
						})
					)
				}
			}
		}
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* notificationPopupSaga() {
	yield* takeEvery(notificationPopupSlice.actions.showMessage.type, showMessageSaga)
}
